import { Button } from "src/components/01_atoms/button";
import { Icon } from "src/components/01_atoms/icon";
import { Outlet } from "src/components/01_atoms/outlet";
import { Text } from "src/components/01_atoms/text";
import { useGetContact } from "src/hooks/data";
import { useClaimStatusSidebar } from "src/hooks/use-claim-status-sidebar";
import { styled, theme } from "src/styles/stitches/theme";

const Container = styled(Outlet, {
  padding: theme.spacing.spacing20px,
  background: theme.colors.fillWarning,
  borderRadius: `0 0 ${theme.radii[24]} ${theme.radii[24]}`,

  "@bp3": {
    padding: theme.spacing.spacing24px,
  },
});

const Title = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.5rem",

  "@bp3": {
    flexDirection: "row",
  },
});

const StyledText = styled(Text, {
  textAlign: "center",

  "@bp3": {
    textAlign: "left",
  },
});

const StyledButton = styled(Button, {
  "@bp3": {
    alignSelf: "start",
  },
});

export function NeedInfoCardSection() {
  const { data } = useGetContact();
  const { setIsNeedInfoDetailSidebarOpen } = useClaimStatusSidebar();

  if (!data) {
    return null;
  }

  return (
    <Container vertical="spacing8px" align="center">
      <Title>
        <Icon name="filledWarning" color="iconSecondaryDefault" />
        <StyledText variant="paragraph2-Bold" color="textSecondaryDefault">
          Votre demande a été traitée : il nous manque des informations
        </StyledText>
      </Title>
      <StyledText variant="paragraph2-Medium" color="textSecondaryDefault">
        Vous avez reçu un mail à {data.email} avec le détail de notre demande. À réception de vos
        informations manquantes, votre demande repart pour 2 jours ouvrés de traitement.
      </StyledText>
      <StyledButton
        type="button"
        variant="smallActionSecondary"
        iconRight="arrowRight"
        onClick={() => setIsNeedInfoDetailSidebarOpen(true)}
      >
        En savoir plus
      </StyledButton>
    </Container>
  );
}
